import { Modal, Row , Col } from "react-bootstrap";

import { useEffect, useState } from "react";
import CreateSignature from "components/CreateSignature";
import { useSelector } from "react-redux";
import apis from "services";
import PDFViewer from "components/PDFViewer";
import { CircularProgress } from "@mui/material";

const SignatureModal = ({ status, toggleModalSignature }) => {
  const { user } = useSelector((store) => store.user);
  const [loading, setLoading] = useState(false);
  const [kyc, setKYC] = useState({});

  const getKYC = async () => {
    try {
      setLoading(true);

      const response = await apis.userKYC(user?.id);
      if (response?.data?.status) {
        console.log(response?.data, "DATAA");
        setKYC(response?.data?.kyc);
      }
      setLoading(false);
    } catch (e) {
      console.log(e.message);

      setLoading(false);
    }
  };

  useEffect(() => {
    if (user?.id) {
      getKYC();
    }
  }, [status]);

  return (
    <Modal
      show={status}
      onHide={toggleModalSignature}
      centered
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>KYC Contract Sign</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <>
            <div className="d-flex justify-content-center align-items-center m-5">
              <CircularProgress color="error" />
            </div>
          </>
        ) : (
          <Row>
              <Col lg={12} className="mb-4"><h5>Please sign the contract for the pending investment procedure!</h5></Col>
              
           <Col md={12} lg={8} >
              <PDFViewer file={kyc?.file}></PDFViewer>
              </Col>
              <Col md={12} lg={4} className='mt-3' >
              <CreateSignature toggleModalSignature={toggleModalSignature}/>
              </Col>
          </Row>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default SignatureModal;
